import gql from 'graphql-tag'

export const UPLOAD_NOTIFICATION_ATTACHMENT_MUTATION = gql`
  mutation UploadNotificationAttachment ($data: UploadNotificationAttachmentInput!) {
    uploadNotificationAttachment(data: $data) {
      key
      url
      mimeType
      size
    }
  }
`

export const CREATE_NOTIFICATION_MUTATION = gql`
  mutation CreateNotification ($data: CreateNotificationInput!) {
    createNotification(data: $data) {
      id
    }
  }
`
